// extracted by mini-css-extract-plugin
export default {"wrapper":"Partners-module--wrapper--VBhyF","title":"Partners-module--title--CtS4m","slider":"Partners-module--slider--mmzCx","slide":"Partners-module--slide--u7rBX"};